import { inject, Injectable } from "@angular/core";
import { ConstructAPI } from "src/app/API/constructAPI";
import { RestApiService } from "src/app/API/restapi";
import { Account, IAPIAccount } from "src/model/account.model";
import { map } from "rxjs/operators";



@Injectable({
    providedIn: 'root'
})
export class CompanyAccountAdapter {

    adapt(item: any): Account {
        return new Account(
            item.id,
            item.accountNumber,
            item.name,
            item.holderName,
            item.balance,
            item.companyId,
            item.username

        )
    }


    toApiModel(account: Account): IAPIAccount {
        return {
            number: account.AccountNumber,
            name: account.Name,
            holderName: account.HolderName,
            companyId: account.CompanyId,
            initialAccountBalance: account.InitialAccountBalance,
            initialAccountDate: account.InitialAccountDate
        }
    }
}


@Injectable({
    providedIn: 'root'
})

export class AccountService {
    private api = inject(RestApiService);
    private constructApi = inject(ConstructAPI);
    private adapter = inject(CompanyAccountAdapter);



    getAllAccountsOfCompany(companyId: number): Promise<Account[]> {
        return new Promise<Account[]>((resolve, reject) => {
            this.api.get<Account[]>(this.constructApi.getAccountsOfCompany(companyId)).pipe(
                map(data => data.map(d => this.adapter.adapt(d)
                ))
            ).subscribe(
                {
                    next: (response) => { resolve(response) },
                    error: err => {
                        this.api.handleError(err);
                        console.error('Failed to get all account of company: ', err);
                        reject(err);
                    }
                }
            )
        })
    }
}